import Vue from 'vue'
import MyPartytown from '@/components/MyPartytown'

export default Vue.component('use-partytown', MyPartytown)